import { Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'

import GlobalStore from './GlobalStore'

import './App.css'
import Account from './pages/Account/Account'
import Home from './pages/Home/Home'
import Tournaments from './pages/Tournaments/Tournaments'
import Tournament from './pages/Tournament/Tournament'
import Categories from './pages/Categories/Categories'
import Players from './pages/Players/Players'
import Venues from './pages/Venues/Venues'
import SettingsAccount from './pages/SettingsAccount/SettingsAccount'
import Community from './pages/Community/Community'
import Login from './pages/Login/Login'
import OrganizerRegistration from './pages/OrganizerRegistration/OrganizerRegistration'
import Info from './pages/Info/Info'
import RequireAuth from './pages/RequireAuth/RequireAuth'
import PlayerForm from './pages/PlayerForm/PlayerForm'
import VenuesForm from './pages/VenuesForm/VenuesForm'
import CategoryForm from './pages/CategoryForm/CategoryForm'
import PopupError from './components/PopupError/PopupError'
import Missing from './pages/Missing/Missing'
import Communities from './pages/Communities/Communities'

function App() {
	const error = useSelector((state) => state.error.error)


	useEffect(() => {
		GlobalStore.setStore()
	}, [])

	return (
		<div className="root-container">
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/:tournamentUid/g/:guest" element={<Tournament />} />

				<Route element={<RequireAuth />}>
					<Route path="/:tournamentUid/" element={<Tournament />} />
					<Route path="/tournaments" element={<Tournaments />} />
					<Route path="/account" element={<Account />} />
					<Route path="/account/categories" element={<Categories />} />
					<Route path="/account/players" element={<Players />} />
					<Route path="/account/players/form" element={<PlayerForm />} />
					<Route path="/account/venues" element={<Venues />} />
					<Route path="/account/settings" element={<SettingsAccount />} />
					<Route path="/account/community" element={<Community />} />
					<Route path="/communities" element={<Communities />} />
					<Route path="/account/venues/form" element={<VenuesForm />} />
					<Route path="/account/category/form" element={<CategoryForm />} />
				</Route>

				<Route path="/info" element={<Info />} />
				<Route path="/login" element={<Login />} />
				<Route path="/registration" element={<OrganizerRegistration />} />
				<Route path="*" element={<Missing />} />
			</Routes>

			{error && <PopupError error={error} />}
		</div>
	)
}

export default App
